import type * as React from 'react';
import clsx from 'clsx';
import { MAX_PAGE_WIDTH } from '#src/theme/constants.ts';

export function Page({
  centerContent = false,
  children,
  screenHeight = false,
  size = 'full'
}: {
  centerContent?: boolean;
  children?: React.ReactNode;
  screenHeight?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'full';
}) {
  return (
    <div
      className={clsx(
        'mx-auto',
        size === 'xs' && 'sm:max-w-md',
        size === 'sm' && 'sm:max-w-lg',
        size === 'md' && 'sm:max-w-2xl',
        size === 'lg' && 'sm:max-w-4xl',
        size === 'full' && MAX_PAGE_WIDTH,

        'px-4 py-10 sm:px-6 lg:px-8',
        '[--gutter-x:--spacing(4)] [--gutter-y:--spacing(10)] sm:[--gutter-x:--spacing(6)] lg:[--gutter-x:--spacing(8)]',

        centerContent && 'sm:flex sm:flex-col sm:items-stretch sm:justify-center',

        screenHeight && 'min-h-screen'
      )}
    >
      {centerContent ? <div>{children}</div> : children}
    </div>
  );
}
